import { Routes } from '@angular/router';
import { NavAutomationComponent } from '@app/features/nav-automation/pages/nav-automation.component';
import { networkTagsRoutes } from '@app/features/merakis/modules/network-tags/network-tags.routing';
import { merakiAdminAuditRoutes } from '@app/features/merakis/modules/meraki-admin-audit/meraki-admin-audit.routing';
import { merakiGoProvisioningRoutes } from '@app/features/merakis/modules/meraki-go-provisioning/meraki-go-provisioning.routing';
import { rogueAcessPointRoutes } from '@app/features/mists/modules/rogue-ap-audit/rogue-ap-audit.routing';
import { mistGuestWifiRoutes } from '@app/features/mists/modules/guest-wifi/guest-wifi.routing';
import { siteAuditRoutes } from '@app/features/site-audit/site-audit.routing';
import { chainAuditRoutes } from "@app/features/chain-audit/chain-audit.routing";
import { cradlepointProvisioningRoutes } from '../cradlepoints/modules/cradlepoint-provisioning/cradlepoint-provisioning.routing';
import { RouteAccessGuard } from '@app/core/guards/route-access.guard';
import { kevlar2Routes } from '../kevlar2-validation/kevlar2-validation.routing';
import { kevlar2ConfigRoutes } from '../kevlar2-config/kevlar2-config.routing';
import { fortigateProvisioningRoutes } from '../fortigates/modules/fortigate-provisioning/fortigate-provisioning.routing';
import { siteIpInfoRoutes } from '../site-ip-info/site-ip-info.routing';

export const navAutomationRoutes: Routes = [
    {
        path: 'automation',
        children: [
            {
                path: '',
                component: NavAutomationComponent,
                data: {
                    authorities: ['ADMIN', 'RESTAURANT_VIEW', 'UPDATE', 'INTL', 'DFS', 'CRADLEPOINT_PRO']
                },
                canActivate: [RouteAccessGuard]
            },
            ...networkTagsRoutes,
    ...merakiAdminAuditRoutes,
    ...merakiGoProvisioningRoutes,
    ...rogueAcessPointRoutes,
    ...mistGuestWifiRoutes,
    ...siteAuditRoutes,
    ...chainAuditRoutes,
    ...cradlepointProvisioningRoutes,
    ...kevlar2Routes,
    ...kevlar2ConfigRoutes,
            ...fortigateProvisioningRoutes,
            ...siteIpInfoRoutes
        ]
    }
]